import { ReactNode } from 'react';

type Layout2x1Props = {
  alignment?: 'left' | 'center' | 'right';
  block1?: ReactNode;
  block2?: ReactNode;
  children?: ReactNode;
  className?: string;
  variant?: 'contained' | 'wide';
};

const textAlignMap: Record<NonNullable<Layout2x1Props['alignment']>, string> = {
  center: 'text-center',
  left: 'text-left',
  right: 'text-right',
};

const Layout2x1 = ({ alignment = 'left', block1, block2, children, className, variant = 'contained' }: Layout2x1Props): JSX.Element => {
  const isWide = variant === 'wide';
  const outerClass = isWide ? 'sm:mx-16 md:mx-32 grid grid-cols-1 sm:grid-cols-2 gap-32' : 'container';
  const middleClass = isWide ? 'contents' : 'inline-flex xs:space-y-64';
  const rowClass = isWide ? 'contents' : 'row';
  const colClass = isWide ? '' : 'col-span-12 xs:col-span-6';

  return (
    <div className={`${outerClass} ${textAlignMap[alignment]} ${className ? className : ''}`}>
      {!isWide && children && (
        <div className="row">
          <div className="col-span-1 xs:hidden md:col-span-1 md:block" />
          <div className="col-span-11 xs:col-span-9 sm:col-span-8 md:col-span-6 lg:col-span-5">{children}</div>
        </div>
      )}
      <div className={middleClass}>
        {block1 && block2 && (
          <div className={rowClass}>
            <div className={colClass}>{block1}</div>
            <div className={colClass}>{block2}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Layout2x1;
